export const investmentFormData = [
  {
    id: 1,
    h2: 'Te ayudamos a elegir la mejor opción de inversión para ti',
    h3: 'Déjanos tus datos y trabajaremos juntos para encontrar la mejor alternativa de inversión para ti.',
    btn: 'Enviar',
  },
];
